import { Text } from '@lmc/ui-kit/src/general'
import { type FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type {
  ClockIn,
  ClockInTeamMember,
  RotaEventInstance
} from 'screens/Rostering/types'
import styled from 'styled-components'
import { getStatus } from './utils'
import { ClockInOutWarnings } from './Warnings'

export const Status: FC<{
  revisionDetail: RotaEventInstance
  teamMember: ClockInTeamMember
}> = ({ revisionDetail, teamMember }) => {
  const { teamMemberId } = teamMember

  const { t } = useTranslation()

  const clockInOutDetails = useMemo(
    () =>
      revisionDetail?.clockIns?.find(
        (clockIn: ClockIn) => clockIn.teamMemberId === teamMemberId
      ),
    [revisionDetail, teamMemberId]
  )

  const status = getStatus({ clockInOutDetails })

  return (
    <StatusContainer>
      <ClockInOutWarnings warnings={teamMember.warnings} />
      <Text>{t(status.label)}</Text>
      {status.icon}
    </StatusContainer>
  )
}

const StatusContainer = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 4px;
  margin-right: 16px;
`
